export const CHANGE_WAIT_BLOCK = 'CHANGE_WAIT_BLOCK';
export const STEP_WAIT_BLOCK = 'STEP_WAIT_BLOCK';
export const ERROR_WAIT_BLOCK = 'ERROR_WAIT_BLOCK';
export const IS_LOGIN = 'IS_LOGIN';
export const CHANGE_ID = 'CHANGE_ID';
export const CHANGE_PASSWORD = 'CHANGE_PASSWORD';
export const CHANGE_DATA = 'CHANGE_DATA';
export const CHANGE_USER = 'CHANGE_USER';
export const CHANGE_EXPIRE_IN = 'CHANGE_EXPIRE_IN';
export const CHANGE_IS_CHECKED = 'CHANGE_IS_CHECKED';

// =========================================================================
//                                 ADMIN
// =========================================================================

// -------------------------
// SIGNUP
// -------------------------

export function handleSessionExpired(dispatch, jqXHR, textStatus, errorThrown) {
    dispatch({type: IS_LOGIN, payload: {isLogin: false}});
    dispatch({type: CHANGE_ID, payload: {id: ""}});
    dispatch({type: CHANGE_PASSWORD, payload: {password: ""},});
    dispatch({type: CHANGE_DATA, payload: {data: undefined},});
    dispatch({type: CHANGE_USER, payload: {user: ""}});
    dispatch({type: CHANGE_EXPIRE_IN, payload: {expireIn: ""}});
    dispatch({type: CHANGE_IS_CHECKED, payload: {isChecked: true}});

}

export function signUp(info) {
    return (dispatch, getState) => {
        let datos = parserBasicData(info);
        datos.imageData = undefined;
        datos.galeria_imagenes_protectora = undefined;
        $.ajax({
            type: 'POST',
            data: JSON.stringify(datos),
            dataType: 'json',
            contentType: 'application/json',
            url: '/api/protectora',
        })
            .done(function (response, textStatus, jqXHR) {
                dispatch({type: CHANGE_ID, payload: {id: response._id}});
                // dispatch({type: STEP_WAIT_BLOCK, payload: {stepWaitBlock: 2}});
                dispatch({type: STEP_WAIT_BLOCK, payload: {stepWaitBlock: 201}});

            })
            .fail(function (jqXHR, textStatus, errorThrown) {
                let errorStr;
                if (typeof jqXHR.responseJSON === 'object' && jqXHR.responseJSON.error !== undefined){
                    errorStr = Array.isArray(jqXHR?.responseJSON?.error) && jqXHR?.responseJSON?.error
                        .map((err) => err.msg)
                        .join(', ')
                        .replace(/,(?!.*,)/gim, ' y');
                } else {
                    errorStr = jqXHR.responseJSON ? jqXHR.responseJSON : "Hubo un error inesperado en el registro :(";
                }

                if (console && console.log){
                    //console.log('La solicitud a fallado: ' + errorStr);
                }

                dispatch({
                    type: ERROR_WAIT_BLOCK,
                    payload: {errorWaitBlock: errorStr},
                });
                dispatch({
                    type: STEP_WAIT_BLOCK,
                    payload: {stepWaitBlock: jqXHR.status},
                });
            });
    };
}

// -------------------------
// LOGIN
// -------------------------

export function login(info) {
    return (dispatch, getState) => {
        let datos = parserBasicData(info);
        let datos_base64 = btoa(datos.user + ':' + datos.password);
        $.ajax({
            type: 'POST',
            url: '/api/login/protectora',
            crossDomain: true,
            beforeSend: function (req) {
                req.setRequestHeader('Authorization', 'Basic ' + datos_base64);
            },
        })
            .done(function (response, textStatus, jqXHR) {
                dispatch({type: IS_LOGIN, payload: {isLogin: true}});
                dispatch({type: CHANGE_ID, payload: {id: response._id}});
                dispatch({type: CHANGE_PASSWORD, payload: {password: datos.password},});
                dispatch({type: CHANGE_USER, payload: {user: datos.user}});
                dispatch({type: CHANGE_DATA, payload: {data: response.data}});
                dispatch({type: CHANGE_EXPIRE_IN, payload: {expireIn: response.expireIn}});
                dispatch({type: CHANGE_IS_CHECKED, payload: {isChecked: true}});
                dispatch({type: STEP_WAIT_BLOCK, payload: {stepWaitBlock: 200}});
            })
            .fail(function (jqXHR, textStatus, errorThrown) {
                let errorStr;
                if (typeof jqXHR.responseJSON === 'object' && jqXHR.responseJSON.error !== undefined){
                    errorStr = jqXHR.responseJSON.error
                        .map((err) => err.msg)
                        .join(', ')
                        .replace(/,(?!.*,)/gim, ' y');
                } else {
                    errorStr = jqXHR.responseJSON ? jqXHR.responseJSON : "Hubo un error inesperado al iniciar sesión :(";
                }

                if (console && console.log){
                    //console.log('La solicitud a fallado: ' + errorStr);
                }
                dispatch({type: ERROR_WAIT_BLOCK, payload: {errorWaitBlock: errorStr},});
                dispatch({type: STEP_WAIT_BLOCK, payload: {stepWaitBlock: jqXHR.status},});
            });
    };
}


export function getInfoLoginProtectora(info) {
    return (dispatch, getState) => {
        let datos = parserBasicData(info);
        let datos_base64 = btoa(datos.user + ':' + datos.password);
        $.ajax({
            type: 'GET',
            url: '/api/login/protectora/info',
            crossDomain: true,
            beforeSend: function (req) {
                req.setRequestHeader('Authorization', 'Basic ' + datos_base64);
            },
        })
            .done(function (response, textStatus, jqXHR) {
                // dispatch({type: IS_LOGIN, payload: {isLogin: true}});
                // dispatch({type: CHANGE_ID, payload: {id: response._id}});
                // dispatch({type: CHANGE_PASSWORD, payload: {password: datos.password},});
                // dispatch({type: CHANGE_USER, payload: {user: datos.user}});
                dispatch({type: CHANGE_DATA, payload: {data: response.data}});
                // dispatch({type: CHANGE_EXPIRE_IN, payload: {expireIn: response.expireIn}});
                // dispatch({type: CHANGE_IS_CHECKED, payload: {isChecked: true}});
                // dispatch({type: STEP_WAIT_BLOCK, payload: {stepWaitBlock: 200}});
            })
            .fail(function (jqXHR, textStatus, errorThrown) {
                let errorStr;
                if (typeof jqXHR.responseJSON === 'object' && jqXHR.responseJSON.error !== undefined){
                    errorStr = jqXHR.responseJSON.error
                        .map((err) => err.msg)
                        .join(', ')
                        .replace(/,(?!.*,)/gim, ' y');
                } else {
                    errorStr = jqXHR.responseJSON ? jqXHR.responseJSON : "Hubo un error inesperado al iniciar sesión :(";
                }

                if (console && console.log){
                    //console.log('La solicitud a fallado: ' + errorStr);
                }
                dispatch({type: ERROR_WAIT_BLOCK, payload: {errorWaitBlock: errorStr},});
                dispatch({type: STEP_WAIT_BLOCK, payload: {stepWaitBlock: jqXHR.status},});
            });
    };
}

export function checkIsLogin() {
    //console.log("actionsAdmin::checkIsLogin()")
    return (dispatch, getState) => {
        // let datos = parserBasicData(info);
        // let datos_base64 = btoa(datos.user + ':' + datos.password);
        $.ajax({
            type: 'GET',
            url: '/api/login/protectora/checkIsLogin',
            crossDomain: true,
            // beforeSend: function (req) {
            //   req.setRequestHeader('Authorization', 'Basic ' + datos_base64);
            // },
        })
            .done(function (response, textStatus, jqXHR) {

                //console.log("actionsAdmin::checkIsLogin()::done() -> isLogin = " + response.isLogin)
                if (response?.isLogin){
                    dispatch({type: IS_LOGIN, payload: {isLogin: true}});
                    dispatch({type: CHANGE_ID, payload: {id: response._id}});
                    dispatch({type: CHANGE_EXPIRE_IN, payload: {expireIn: response.expireIn}});
                    dispatch({type: CHANGE_IS_CHECKED, payload: {isChecked: true}});
                } else {
                    handleSessionExpired(dispatch, response, textStatus, jqXHR)
                }
            })
            .fail(function (jqXHR, textStatus, errorThrown) {
                let errorStr;
                //console.log("actionsAdmin::checkIsLogin()::fail()")

                if (typeof jqXHR.responseJSON === 'object' && jqXHR.responseJSON.error !== undefined){
                    errorStr = jqXHR.responseJSON.error.map((err) => err.msg).join(', ').replace(/,(?!.*,)/gim, ' y');
                } else {
                    errorStr = jqXHR.responseJSON ? jqXHR.responseJSON : "Hubo un error inesperado al comprobar sesión activa:(";
                }

                console.log('La solicitud a fallado: ' + errorStr);
                if (jqXHR.status === 401){
                    handleSessionExpired(dispatch, jqXHR, textStatus, errorThrown)
                }
            });
    };
}


export function changePassword(info, adminProtectora) {
    return (dispatch, getState) => {
        const datos = {
            password_anterior: info.oldPassword,
            password_nueva: info.newPassword,
        };
        let datos_base64 = btoa(adminProtectora.user + ':' + adminProtectora.password);
        $.ajax({
            type: 'PUT',
            data: datos,
            dataType: 'json',
            concentType: 'application/json',
            crossDomain: true,
            beforeSend: function (req) {
                req.setRequestHeader('Authorization', 'Basic ' + datos_base64);
            },
            url: `/api/protectora/${adminProtectora.id}/password`,
        })
            .done(function (response, textStatus, jqXHR) {
                dispatch({
                    type: CHANGE_PASSWORD,
                    payload: {password: info.newPassword},
                });
                dispatch({type: STEP_WAIT_BLOCK, payload: {stepWaitBlock: 200}});
            })
            .fail(function (jqXHR, textStatus, errorThrown) {
                let errorStr;
                if (
                    typeof jqXHR.responseJSON === 'object' &&
                    jqXHR.responseJSON.error !== undefined
                ){
                    errorStr = jqXHR.responseJSON.error
                        .map((err) => err.msg)
                        .join(', ')
                        .replace(/,(?!.*,)/gim, ' y');
                } else {
                    errorStr = jqXHR.responseJSON ? jqXHR.responseJSON : "Hubo un error inesperado al cambiar contraseña :(";
                }

                if (console && console.log){
                    console.log('La solicitud a fallado: ' + errorStr);
                }
                dispatch({
                    type: ERROR_WAIT_BLOCK,
                    payload: {errorWaitBlock: errorStr},
                });
                dispatch({
                    type: STEP_WAIT_BLOCK,
                    payload: {stepWaitBlock: jqXHR.status},
                });
            });
    };
}

export function logout() {
    return (dispatch) => {

        dispatch({type: IS_LOGIN, payload: {isLogin: false}});

        $.ajax({
            type: 'DELETE',
            data: {},
            dataType: 'json',
            url: '/api/login/protectora',
        })
            .done((response) => {
                handleSessionExpired(dispatch, undefined, undefined, undefined)
                // dispatch({type: STEP_WAIT_BLOCK, payload: {stepWaitBlock: 200}});
            })
            .fail((jqXHR, textStatus, _errorThrown) => {
                let errorStr;
                if (typeof jqXHR.responseJSON === 'object' && jqXHR.responseJSON.error !== undefined){
                    errorStr = jqXHR.responseJSON.error
                        .map((err) => err.msg)
                        .join(', ')
                        .replace(/,(?!.*,)/gim, ' y');
                } else {
                    errorStr = jqXHR.responseJSON ? jqXHR.responseJSON : "Hubo un error inesperado al cerrar sesión:(";
                }

                if (console && console.log){
                    console.log('La solicitud a fallado: ' + errorStr);
                }
            });
    };
}

export function changeErrorWaitBlock(error) {
    return (dispatch, getState) => {
        dispatch({type: ERROR_WAIT_BLOCK, payload: {errorWaitBlock: error}});
    };
}

// -------------------------
// PROFILE
// -------------------------

export function changeProfile(info, adminProtectora) {
    return (dispatch, getState) => {
        let datos = parserBasicData(info);
        let datos_base64 = btoa(datos.email + ':' + adminProtectora.password);
        datos.imageData = null;
        datos.galeria_imagenes_protectora = null;
        $.ajax({
            type: 'PUT',
            data: JSON.stringify(datos),
            dataType: 'json',
            contentType: 'application/json',
            crossDomain: true,
            // beforeSend: function (req) {
            //     req.setRequestHeader('Authorization', 'Basic ' + datos_base64);
            // },
            url: '/api/protectora',
        })
            .done(function (response, textStatus, jqXHR) {
                dispatch({type: STEP_WAIT_BLOCK, payload: {stepWaitBlock: 2}});
            })
            .fail(function (jqXHR, textStatus, errorThrown) {
                let errorStr;
                if (typeof jqXHR.responseJSON === 'object' && jqXHR.responseJSON.error !== undefined){
                    errorStr = jqXHR.responseJSON.error
                        .map((err) => err.msg)
                        .join(', ')
                        .replace(/,(?!.*,)/gim, ' y');
                } else {
                    errorStr = jqXHR.responseJSON ? jqXHR.responseJSON : "Hubo un error inesperado al guardar los datos :(";
                }
                if (jqXHR.status === 401){
                    handleSessionExpired(dispatch, jqXHR, textStatus, errorThrown)
                }
                if (console && console.log){
                    console.log('La solicitud a fallado: ' + errorStr);
                }
                dispatch({
                    type: ERROR_WAIT_BLOCK,
                    payload: {errorWaitBlock: errorStr},
                });
                dispatch({
                    type: STEP_WAIT_BLOCK,
                    payload: {stepWaitBlock: jqXHR.status},
                });
            });
    };
}

// ---------------------------
// FUNCIONES AUXILIARES SIGNUP
// ---------------------------

function parserBasicData(data) {
    let dataReturn = {};
    Object.keys(data).forEach((val) => {
        if (val === 'name' && data[val] !== undefined && data[val] !== ''){
            dataReturn.nombre = data[val];
        } else if (val === 'tipoEntidad' && data[val] !== undefined && data[val] !== ''){
            dataReturn.tipoEntidad = data[val];
        } else if (val === 'otroTipoEntidad' && data[val] !== undefined && data[val] !== ''){
            dataReturn.otroTipoEntidad = data[val];
        } else if (val === 'contratoMunicipal' && data[val] !== undefined){
            dataReturn.contratoMunicipal = data[val];
        } else if (val === 'user' && data[val] !== undefined && data[val] !== ''){
            dataReturn.user = data[val];
        } else if (val === 'password' && data[val] !== undefined && data[val] !== ''){
            dataReturn.password = data[val];
        } else if (val === 'passwordRepeat' && data[val] !== undefined && data[val] !== ''){
            dataReturn.passwordRepeat = data[val];
        } else if (val === 'codPostal' && data[val] !== undefined && data[val] !== ''){
            dataReturn.cod_postal = data[val];
        } else if (val === 'direccion' && data[val] !== undefined && data[val] !== ''){
            dataReturn.calle = data[val];
        } else if (val === 'numDir' && data[val] !== undefined && data[val] !== ''){
            dataReturn.numero = data['numDir'];
        } else if (val === 'nif' && data[val] !== undefined && data[val] !== ''){
            dataReturn.NIF = data[val];
        } else if (val === 'ocultarDireccionExacta' && data[val] !== undefined){
            dataReturn.ocultarDireccionExacta = data[val];
        } else if (val === 'contratoMunicipal' && data[val] !== undefined){
            dataReturn.contratoMunicipal = data[val];
        } else if (val === 'motivoOcultarDir' && data[val] !== undefined && data[val] !== ''){
            dataReturn.motivoOcultarDir = data[val];
        } else if (val === 'URL' && data[val] !== undefined && data[val] !== ''){
            dataReturn.URL = data[val];
        } else if (val === 'facebook' && data[val] !== undefined && data[val] !== ''){
            dataReturn.facebook = data[val];
        } else if (val === 'instagram' && data[val] !== undefined && data[val] !== ''){
            dataReturn.instagram = data[val];
        } else if (val === 'twitter' && data[val] !== undefined && data[val] !== ''){
            dataReturn.twitter = data[val];
        } else if (val === 'teaming' && data[val] !== undefined && data[val] !== ''){
            dataReturn.teaming = data[val];
        } else if (val === 'descripcion' && data[val] !== undefined && data[val] !== ''){
            dataReturn.descripcion = data[val];
        } else if (val === 'colaboradores' && data[val] !== undefined && data[val].length > 0){
            dataReturn.colaboradores = data[val];
        } else if (val === 'email' && data[val] !== undefined && data[val] !== ''){
            dataReturn.email = data[val];
        } else if (val === 'realizaEnvios' && data[val] !== undefined){
            dataReturn.realiza_envios = data[val];
        } else if (val === 'imageData' && data[val] !== undefined && Object.keys(data[val]).length !== 0){
            dataReturn.imageData = data[val];
        }
    });

    return dataReturn;
}

export function sendImage(info, infoAdminProtectora) {
    return (dispatch) => {
        if (Object.keys(info.imageData).length !== 0){
            const user = infoAdminProtectora.user !== '' ? infoAdminProtectora.user : info.email;
            const password = infoAdminProtectora.password !== '' ? infoAdminProtectora.password : info.password;
            const datos_base64 = btoa(user + ':' + password);

            info.imageData.data = null;
            if (info.imageData.isModified){
                $.ajax({
                    type: 'PUT',
                    dataType: 'json',
                    contentType: 'application/json',
                    processData: false,
                    cache: false,
                    crossDomain: true,
                    beforeSend: function (req) {
                        req.setRequestHeader('Authorization', 'Basic ' + datos_base64);
                    },
                    url: '/api/protectora/' + infoAdminProtectora.id + '/imagen',
                    data: JSON.stringify({imageData: info.imageData}),
                })

                    .done(function (_response, _textStatus, _jqXHR) {
                        dispatch({type: STEP_WAIT_BLOCK, payload: {stepWaitBlock: 201}});
                    })
                    .fail(function (jqXHR, textStatus, _errorThrown) {
                        let errorStr;
                        if (typeof jqXHR.responseJSON === 'object' && jqXHR.responseJSON.error !== undefined){
                            errorStr = jqXHR.responseJSON.error
                                .map((err) => err.msg)
                                .join(', ')
                                .replace(/,(?!.*,)/gim, ' y');
                        } else {
                            errorStr = jqXHR.responseJSON ? jqXHR.responseJSON : "Hubo un error inesperado al guardar la imagen principal :(";
                        }

                        if (console && console.log){
                            console.log('La solicitud a fallado: ' + errorStr);
                        }
                        dispatch({
                            type: ERROR_WAIT_BLOCK,
                            payload: {errorWaitBlock: errorStr},
                        });
                        dispatch({
                            type: STEP_WAIT_BLOCK,
                            payload: {stepWaitBlock: jqXHR.status},
                        });
                    });

            } else {
                dispatch({type: STEP_WAIT_BLOCK, payload: {stepWaitBlock: 3}});
            }
        } else {
            dispatch({type: STEP_WAIT_BLOCK, payload: {stepWaitBlock: 201}});
        }
    };
}


export function modifyImage(info, infoAdminProtectora) {
    return (dispatch) => {
        if (Object.keys(info.imageData).length !== 0){
            const user = infoAdminProtectora.user !== '' ? infoAdminProtectora.user : info.email;
            const password =
                infoAdminProtectora.password !== '' ? infoAdminProtectora.password : info.password;
            const datos_base64 = btoa(user + ':' + password);

            info.imageData.data = null;
            if (info.imageData.isModified){
                $.ajax({
                    type: 'PUT',
                    dataType: 'json',
                    contentType: 'application/json',
                    processData: false,
                    cache: false,
                    crossDomain: true,
                    beforeSend: function (req) {
                        req.setRequestHeader('Authorization', 'Basic ' + datos_base64);
                    },
                    url: '/api/protectora/' + infoAdminProtectora.id + '/imagen',
                    data: JSON.stringify({imageData: info.imageData}),
                })

                    .done(function (_response, _textStatus, _jqXHR) {
                        dispatch({type: STEP_WAIT_BLOCK, payload: {stepWaitBlock: 3}});
                    })
                    .fail(function (jqXHR, textStatus, _errorThrown) {
                        let errorStr;
                        if (typeof jqXHR.responseJSON === 'object' && jqXHR.responseJSON.error !== undefined){
                            errorStr = jqXHR.responseJSON.error
                                .map((err) => err.msg)
                                .join(', ')
                                .replace(/,(?!.*,)/gim, ' y');
                        } else {
                            errorStr = jqXHR.responseJSON ? jqXHR.responseJSON : "Hubo un error inesperado al guardar la imagen principal :(";
                        }

                        if (console && console.log){
                            console.log('La solicitud a fallado: ' + errorStr);
                        }
                        dispatch({
                            type: ERROR_WAIT_BLOCK,
                            payload: {errorWaitBlock: errorStr},
                        });
                        dispatch({
                            type: STEP_WAIT_BLOCK,
                            payload: {stepWaitBlock: jqXHR.status},
                        });
                    });
            } else {
                dispatch({type: STEP_WAIT_BLOCK, payload: {stepWaitBlock: 3}});
            }
        } else {
            dispatch({type: STEP_WAIT_BLOCK, payload: {stepWaitBlock: 201}});
        }
    };
}

export function sendImagesProtectora(info, infoAdminProtectora) {
    return (dispatch) => {
        const datos_base64 = btoa(infoAdminProtectora.user + ':' + infoAdminProtectora.password);

        const {galeria_imagenes_protectora} = info;


        const promesas = galeria_imagenes_protectora.filter((img) => img.isModified).map((imageData) => {
            return new Promise((resolve, reject) => {
                imageData.data = null;
                /*console.log("Lanzando peticion --> " + `/api/protectora/${infoAdminProtectora.id}/galeria/imagen/${imageData.order}` + " --> " + JSON.stringify({
                    o: imageData.order,
                    t: imageData.type
                }))*/
                $.ajax({
                    type: "PUT",
                    dataType: "json",
                    processData: false,
                    cache: false,
                    crossDomain: true,
                    contentType: "application/json",
                    // beforeSend: function (req) {
                    //     req.setRequestHeader("Authorization", "Basic " + datos_base64);
                    // },
                    url: `/api/protectora/${infoAdminProtectora.id}/galeria/imagen/${imageData.order}`,
                    data: JSON.stringify({imageData: imageData}),
                })
                    .done(function (_response, _textStatus, _jqXHR) {
                        //console.log("Imagen[" + imageData.type + "] de galeria guardada correctamente")
                        // dispatch({type: STEP_WAIT_BLOCK, order: {stepWaitBlock: 201}});
                        resolve({status: 201, imgNum: imageData.order});
                    })
                    .fail(function (jqXHR, textStatus, _errorThrown) {
                        // console.log("Imagen[" + imgNum + "] de galeria tuvo un error --> " + JSON.stringify(jqXHR.responseJSON))

                        let errorStr;
                        if (typeof jqXHR.responseJSON === "object" && jqXHR.responseJSON.error !== undefined){
                            errorStr = jqXHR.responseJSON.error.map(err => err.msg).join(', ').replace(/,(?!.*,)/gmi, ' y')

                        } else if (typeof jqXHR.responseJSON === "object" && jqXHR.responseJSON.message !== undefined){
                            errorStr = "Hubo un error inesperado al guardar la imagen de la protectora";
                        } else {
                            errorStr = jqXHR.responseJSON ? jqXHR : "Hubo un error inesperado al guarda la imagen " + (imageData.order + 1) + ":(";
                        }

                        if (jqXHR.status === 413){
                            errorStr = 'La imagen ' + (imageData.order + 1) + ' pesa demasiado, máximo 6MB por imagen';
                        }

                        errorStr = errorStr || _errorThrown;

                        if (console && console.log){
                            console.log("La solicitud a fallado. errorStr: " + errorStr);
                        }

                        resolve({status: jqXHR.status, errorStr: errorStr, imgNum: imageData.order})
                    });

            })
        });

        if (promesas.length > 0){


            Promise.all(promesas)
                .then((result) => {
                    let errorStr = result
                        .filter((elem => elem.errorStr))
                        .map((elem, index) => (elem.imgNum + 1) + " por '" + elem.errorStr + "'")
                        .join(', ')
                        .replace(/,(?!.*,)/gmi, ' y');

                    if (errorStr){
                        errorStr = "Error en la imagen: " + errorStr;
                        //console.log("Mensaje de error --> " + errorStr);
                        dispatch({type: ERROR_WAIT_BLOCK, payload: {errorWaitBlock: errorStr}});
                        dispatch({type: STEP_WAIT_BLOCK, payload: {stepWaitBlock: 500}});

                    } else {
                        //console.log("Sin errores en las imagenes :)");
                        dispatch({type: STEP_WAIT_BLOCK, payload: {stepWaitBlock: 200}});
                    }
                })
                .catch((err) => {
                    //console.log("ERROR en las promesas")
                    console.error(err)

                    dispatch({
                        type: ERROR_WAIT_BLOCK,
                        payload: {errorWaitBlock: "Hubo un error inesperado al guardar la galería de imagenes :("}
                    });
                    dispatch({type: STEP_WAIT_BLOCK, payload: {stepWaitBlock: 500}});

                });
        } else {
            //console.log("Sin modificar ninguna imagen");
            // dispatch({type: SHOW_WAIT_BLOCK, payload: {showWaitBlock: false}});
            dispatch({type: STEP_WAIT_BLOCK, payload: {stepWaitBlock: 200}});
        }


        // if (galeria_imagenes_protectora.length > 0) {
        //     const imagesProtectoraOrdered =
        //         galeria_imagenes_protectora && galeria_imagenes_protectora.length > 0
        //             ? galeria_imagenes_protectora.sort((a, b) =>
        //                 a.order > b.order ? 1 : b.order > a.order ? -1 : 0
        //             )
        //             : [];
        //
        //     $.ajax({
        //         type: 'PUT',
        //         dataType: 'json',
        //         contentType: 'application/json',
        //         processData: false,
        //         cache: false,
        //         crossDomain: true,
        //         beforeSend: function (req) {
        //             req.setRequestHeader('Authorization', 'Basic ' + datos_base64);
        //         },
        //         url: `/api/protectora/${infoAdminProtectora.id}/galeria/imagenes`,
        //         data: JSON.stringify({listImagesData: imagesProtectoraOrdered}),
        //     })
        //         .done(function (_response, _textStatus, _jqXHR) {
        //             dispatch({type: STEP_WAIT_BLOCK, payload: {stepWaitBlock: 201}});
        //         })
        //         .fail(function (jqXHR, textStatus, _errorThrown) {
        //             let errorStr;
        //             if (
        //                 typeof jqXHR.responseJSON === 'object' &&
        //                 jqXHR.responseJSON.error !== undefined
        //             ) {
        //                 errorStr = jqXHR.responseJSON.error
        //                     .map((err) => err.msg)
        //                     .join(', ')
        //                     .replace(/,(?!.*,)/gim, ' y');
        //             } else {
        //                 errorStr = jqXHR.responseJSON ? jqXHR.responseJSON: "Hubo un error inesperado :(";
        //             }
        //
        //             if (console && console.log) {
        //                 console.log('La solicitud a fallado: ' + errorStr);
        //             }
        //             dispatch({
        //                 type: ERROR_WAIT_BLOCK,
        //                 payload: {errorWaitBlock: errorStr},
        //             });
        //             dispatch({
        //                 type: STEP_WAIT_BLOCK,
        //                 payload: {stepWaitBlock: jqXHR.status},
        //             });
        //         });
        // } else {
        //     dispatch({type: STEP_WAIT_BLOCK, payload: {stepWaitBlock: 201}});
        // }
    };
}

/**
 * Convert a base64 string in a Blob according to the data and contentType.
 *
 * @param b64Data {String} Pure base64 string without contentType
 * @param contentType {String} the content type of the file i.e (image/jpeg - image/png - text/plain)
 * @param sliceSize {Int} SliceSize to process the byteCharacters
 * @see http://stackoverflow.com/questions/16245767/creating-a-blob-from-a-base64-string-in-javascript
 * @return Blob
 */
/*function b64toBlob(b64Data, contentType, sliceSize) {
    contentType = contentType || '';
    sliceSize = sliceSize || 512;

    var byteCharacters = atob(b64Data);
    var byteArrays = [];

    for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        var slice = byteCharacters.slice(offset, offset + sliceSize);

        var byteNumbers = new Array(slice.length);
        for (var i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
        }

        var byteArray = new Uint8Array(byteNumbers);

        byteArrays.push(byteArray);
    }

    var blob = new Blob(byteArrays, {type: contentType});
    return blob;
}*/

// **************************FIN SIGNUP*******************************
